import { resolveApiUrl } from './localApiOverrides';

export const CDN_BUCKET_URL = import.meta.env.VITE_CDN_BUCKET_URL;
export const MELI_LABELS_BUCKET_URL = import.meta.env
  .VITE_MELI_LABELS_BUCKET_URL;
export const API_INTEGRATION_TEST_BUSINESS_URL: string =
  import.meta.env.VITE_INTEGRATION_TEST_API_URL ?? '';
  
export const API_AUTH_URL = import.meta.env.VITE_API_AUTH_URL;

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const DEFAULT_COMPANY_ID = import.meta.env.VITE_COMPANY_NO_APLICA;

export const API_ATC_URL = resolveApiUrl('atc', `${API_BASE_URL}/atc`);
export const API_BOT_URL = resolveApiUrl('bot', `${API_BASE_URL}/bot`);
export const API_FLEET_URL = resolveApiUrl('fleet', `${API_BASE_URL}/fleet`);
export const API_SCHEDULER = resolveApiUrl(
  'scheduler',
  `${API_BASE_URL}/scheduler`
);
export const API_BUSINESS_URL = resolveApiUrl(
  'business',
  `${API_BASE_URL}/business`
);
export const API_INVENTORY_URL = resolveApiUrl(
  'inventory',
  `${API_BASE_URL}/inventory`
);
export const API_GPS_TRACKER_URL = resolveApiUrl(
  'gps-tracker',
  `${API_BASE_URL}/gps-tracker`
);
export const API_ATTEND_TRACK_URL = resolveApiUrl(
  'attend-track',
  `${API_BASE_URL}/attend-track`
);
export const API_MELI_INTEGRATION_URL = resolveApiUrl(
  'meli-integration',
  `${API_BASE_URL}/meli-integration/api`
);

export const API_BUSINESS_MOBILE_URL = `${API_BUSINESS_URL}/mobile`;
export const API_APPS_VERSIONS_URL = `${API_BUSINESS_MOBILE_URL}/app-versions`;

export const S3_DOCUMENTS_URL = import.meta.env.VITE_S3_DOCUMENTS_URL;
export const HAS_INTEGRATION_TEST_ENVIRONMENT = API_INTEGRATION_TEST_BUSINESS_URL !== '';
